import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@common/components/modal';
import { Button } from '@common/components/Button';
import { FormControl } from '@common/components/form-control';

export class NewUserWnd extends Component {
    handleChange = (e) => {
        this.props.onUserDataChanged(e.target.dataset.field, e.target.value);
    };

    handleUsernameBlur = (e) => {
        this.props.onUserDataChanged(e.target.dataset.field, e.target.value.trim());
    };

    render () {
        const I18n = require('react-redux-i18n').I18n;
        var topLabel = I18n.t('Passwords must contain');

        return (
            <Modal style={{top: '25%'}} dialogClassName="bootstrap-modal-medium" bsClass="bootstrap modal" show={this.props.show} onHide={this.props.onHide} animation={false} backdrop="static">
                <ModalHeader closeButton onHide={this.props.onHide}>
                    <ModalTitle id="lbl-title" style={{color: '#008DCE', fontWeight: 'normal'}}>{I18n.t('New User')}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div>{topLabel}</div>
                    <div className="row" style={{marginTop: '20px'}}>
                        <div id="lbl-user-name" className="col-sm-4" style={{textAlign: 'right', marginTop: '7px', paddingRight: '0px'}}>{I18n.t('User Name')}</div>
                        <div className="col-sm-7">
                            <FormControl
                                id="tx-user-name"
                                className="form-control"
                                type="text"
                                data-field="username"
                                value={this.props.username || ''}
                                onChange={this.handleChange}
                                onBlur={this.handleUsernameBlur}
                            />
                        </div>
                    </div>
                    <div className="row" style={{marginTop: '5px'}}>
                        <div id="lbl-password" className="col-sm-4" style={{textAlign: 'right', marginTop: '7px', paddingRight: '0px'}}>{I18n.t('Password')}</div>
                        <div className="col-sm-7">
                            <FormControl
                                id="tx-password"
                                data-field="password"
                                className="form-control"
                                type="password"
                                value={this.props.password || ''}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="row" style={{marginTop: '5px'}}>
                        <div id="lbl-retype-password" className="col-sm-4" style={{textAlign: 'right', marginTop: '7px', paddingRight: '0px'}}>{I18n.t('Retype Password')}</div>
                        <div className="col-sm-7">
                            <FormControl
                                id="tx-retype-password"
                                className="form-control"
                                type="password"
                                data-field="retypedPassword"
                                value={this.props.retypedPassword || ''}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button id="btn-cancel" key="no" style={{width: "100px"}} onClick={this.props.onHide}>{I18n.t('Cancel')}</Button>
                    <Button id="btn-save" key="ok" type="submit" bsStyle="primary" style={{width: "100px"}} onClick={this.props.onSave}>{I18n.t('Save')}</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

NewUserWnd.propTypes = {
    show: PropTypes.bool.isRequired,
    error: PropTypes.string,
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onUserDataChanged: PropTypes.func.isRequired,
    username: PropTypes.string,
    password: PropTypes.string,
    retypedPassword: PropTypes.string
};